// extracted by mini-css-extract-plugin
export var blockedMessage = "_b5-3";
export var blockedOverlay = "_b5-1";
export var fadeIn = "_b5-2";
export var hereLink = "_b5-0";
export var slideUp = "_b5-4";